import { AnimationEvent } from '@angular/animations';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription, timer } from 'rxjs';

import { toastAnimations, ToastAnimationState } from './toast-animation';
import { TOAST_CONFIG_TOKEN, ToastConfig, ToastData } from './toast-config';
import { ToastRef } from './toast-ref';

@Component({
    selector: 'fcp-toast',
    templateUrl: './fcp-toast.component.html',
    styleUrls: ['./fcp-toast.component.less'],
    animations: [toastAnimations.fadeToast],
    standalone: false
})
export class FcpToastComponent implements OnInit, OnDestroy {
    public animationState: ToastAnimationState = 'default';

    private timeout: Subscription;

    constructor(
        readonly data: ToastData,
        readonly ref: ToastRef,
        @Inject(TOAST_CONFIG_TOKEN) public toastConfig: ToastConfig
    ) {}

    ngOnInit() {
        this.timeout = timer(this.data.timeout).subscribe(() => this.setAnimationState('closing'));
    }

    ngOnDestroy() {
        this.timeout.unsubscribe();
    }

    public handleAction() {
        this.data.action.handler();
        this.close();
    }

    public setAnimationState(state: ToastAnimationState) {
        this.animationState = state;
    }

    public close() {
        this.ref.close();
    }

    public onFadeFinished(event: AnimationEvent) {
        const { toState } = event;
        const isFadeOut = (toState as ToastAnimationState) === 'closing';
        const itFinished = this.animationState === 'closing';

        if (isFadeOut && itFinished) {
            this.close();
        }
    }
}
